<template>
  <l-dialog
    :show="isShow"
    @cancel="cancel"
    :ischa="true"
    :isbtn="false"
    title="查看用户信息"
  >
    <div class="examineWidnow">
      <div class="left-box">
        <img class="avatar" :src="global.ip + data.baseinfo.avatar" />
        <p class="row"><span>姓名：</span>{{ data.baseinfo.nickname }}</p>
        <p class="row"><span>性别：</span>{{ data.baseinfo.sex }}</p>
        <p class="row"><span>年龄：</span>{{ data.baseinfo.age }}</p>
        <p class="row"><span>部门：</span>{{ data.baseinfo.deptname }}</p>
        <p class="row"><span>编号：</span>{{ data.baseinfo.studentId }}</p>
        <p class="row"><span>电话：</span>{{ data.baseinfo.phone }}</p>

        <div class="btn-box" v-if="showEdit">
          <button class="btn" @click="edit()">编辑用户信息</button>
        </div>
      </div>
      <div class="right-box">
        <h3><i></i><span>用户数据统计：</span></h3>

        <ul class="tag">
          <li :class="{ on: data.showDataKey == 'aMonth' }" @click="data.showDataKey = 'aMonth'">近一个月</li>
          <li :class="{ on: data.showDataKey == 'threeMonth' }" @click="data.showDataKey = 'threeMonth'">近三个月</li>
          <li :class="{ on: data.showDataKey == 'all' }" @click="data.showDataKey = 'all'">全部</li>
        </ul>
        <div class="table" v-if="data.static[data.showDataKey]">
          <div class="row row-th">
            <div class="col">新增预约记录</div>
            <div class="col">新增咨询记录</div>
            <div class="col">新增量表测评</div>
          </div>
          <div class="row">
            <div class="col">{{ data.static[data.showDataKey].order }}</div>
            <div class="col">{{ data.static[data.showDataKey].consult }}</div>
            <div class="col">{{ data.static[data.showDataKey].gauge }}</div>
          </div>

          <div class="row row-th">
            <div class="col">新增普查记录</div>
            <div class="col">新增问卷记录</div>
            <div class="col">新增测评预警</div>
          </div>
          <div class="row">
            <div class="col">{{ data.static[data.showDataKey].survey }}</div>
            <div class="col">{{ data.static[data.showDataKey].question }}</div>
            <div class="col">{{ data.static[data.showDataKey].warning }}</div>
          </div>

          <div class="row row-th">
            <div class="col">新增团体测评</div>
            <div class="col">录入测评结果</div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col">{{ data.static[data.showDataKey].team }}</div>
            <div class="col">{{ data.static[data.showDataKey].logging }}</div>
            <div class="col"></div>
          </div>
        </div>

        <h3><i></i><span>近期测评：</span></h3>
        <p class="p-title" v-if="data.latestRecord">量表名称：<span>{{ data.latestRecord.gaugeTitle }}</span></p>
        <!-- <p class="p-score">测评得分：<span>56分</span></p> -->

        <h3><i></i><span>测评结果：</span></h3>
        <template v-if="data.latestRecord && data.latestRecord.result">
          <div v-for="(item, index) of data.latestRecord.result.resultCategory" :key="index">
            <p class="p-score">{{ item.categoryName }}：<span>{{ item.categoryScores }}分</span></p>
            <div class="p-text" v-html="item.result"></div>
          </div>
        </template>

      </div>
    </div>
  </l-dialog>
</template>


<script>
import lDialog from "../../components/lDialog.vue";
export default {
  components: { lDialog },
  data() {
    return {
      isShow: this.show,
      data: {
        baseinfo: {

        },
        static: {
          aMonth: {},
          threeMonth: {},
          all: {},
        },
        showDataKey: 'aMonth',
        latestRecord: null,
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel", this.show);
    },
    save() {
      this.$emit("save");
    },
    edit() {
      this.$emit('edit')
    },

    getUserData () {
      if (!this.id) {
        return
      }
      this.$post("api/user/detail", {
        id: this.id,
      }).then(({ data }) => {
        this.data.baseinfo = data.data.info.baseinfo
        this.data.static = data.data.info.static
        this.data.latestRecord = data.data.info.latestRecord
        if (this.data.latestRecord && this.data.latestRecord.result) {
          this.data.latestRecord.result = JSON.parse(this.data.latestRecord.result)
        }
      })
    },
  },
  watch: {
    show(newV) {
      this.isShow = newV;
    },
    id(){
      this.getUserData()
    },
  },
};
</script>

<style lang='less' scoped>
.examineWidnow {
  display: flex;
  width: 900px;
  height: 550px;
  .left-box {
    position: relative;
    width: 220px;
    padding: 30px 0 0 50px;
    box-sizing: border-box;
    .avatar {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background-color: #f0f0f0;
    }
    .row {
      margin-top: 20px;
      line-height: 1;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #333333;
    }
    .btn-box {
      position: absolute;
      left: 0;
      bottom: 30px;
      width: 100%;
      text-align: center;
      .btn {
        width: auto;
        height: 36px;
        padding: 0 15px;
        background: #3170ff;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .right-box {
    width: 680px;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: auto;
    >h3 {
      display: flex;
      align-items: center;
      line-height: 34px;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      >i {
        display: inline-block;
        width: 6px;
        height: 14px;
        margin-right: 10px;
        background: #3170ff;
        border-radius: 3px;
        vertical-align: middle;
      }
    }
    .tag {
      margin-top: 10px;
      >li {
        display: inline-block;
        width: 112px;
        height: 36px;
        margin-right: 10px;
        background: #eeeeee;
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
      }
      .on {
        background: #3170ff;
        color: #fff;
      }
    }
    .table {
      margin: 10px 0;
      .row {
        display: flex;
        .col {
          width: 210px;
          height: 50px;
          background: #eeeeee66;
          line-height: 50px;
          font-size: 20px;
          text-align: center;
          color: #333333;
        }
        .col+.col {
          margin-left: 1px;
        }
      }
      .row-th {
        .col {
          height: 36px;
          background: #eeeeee;
          line-height: 36px;
          font-size: 14px;
        }
      }
    }

    .p-title {
      line-height: 32px;
      font-size: 14px;
      text-align: left;
      color: #555555;
    }
    .p-score {
      line-height: 32px;
      font-size: 14px;
      text-align: left;
      color: #555555;
      span {
        color: #ff9500;
      }
    }
    .p-text {
      line-height: 28px;
      font-size: 14px;
      text-align: left;
      color: #555555;
    }

  }
}
</style>